import request from '../../utils/request';
export async function requestTagTemplateList() {
  return request({ url: 'tag/template/list', method: 'get', headers: 'json' });
}
export async function requestTagTemplateAdd(params) {
  return request({ url: 'tag/template/add', headers: 'json', params });
}
export async function requestTagTemplateUpdate(params) {
  return request({ url: 'tag/template/update', headers: 'json', params });
}
export async function requestTagTemplateUpdateStatus(params) {
  return request({ url: 'tag/template/updateStatus', headers: 'json', params });
}
export async function requestTagTemplateStallRelationList(params) {
  return request({
    url: 'tag/template/stall/relation/list',
    method: 'get',
    headers: 'json',
    params,
  });
}
export async function requestTagTemplateStallRelationAdd(params) {
  return request({
    url: 'tag/template/stall/relation/add',
    headers: 'json',
    params,
  });
}
export async function requestTagTemplateStallRelationRemove(params) {
  return request({
    url: 'tag/template/stall/relation/remove',
    headers: 'json',
    params,
  });
}

/**
 * 商行针式打印 — 销售单模板列表
 * @returns {Promise<{ code?: number, data?: Array<{
 *   id?: number, templateName?: string, sourceType?: number,
 *   defaultTemplateFlag?: boolean, createTime?: number,
 *   cxmJolimarkTypeEnum?: string,
 *   templateDetail?: { printStyle?: string, fieldList?: string[], customContent?: string,
 *     headerImage?: object, qrCodeImage?: object, titleBO?: object }
 * }>, msg?: string }>}
 */
export async function requestNeedleOrderTemplateList(params) {
  return request({
    url: 'tag/template/needle/order/list',
    method: 'get',
    headers: 'json',
    params,
  });
}

/**
 * 商行针式打印 — 销售单模板新增
 * @param {{ stallId: number, templateName?: string, id?: number, templateBO?: { printStyle?: string, productFieldList?: string[] } }} params
 */
export async function requestNeedleOrderTemplateAdd(params) {
  return request({
    url: 'tag/template/needle/order/add',
    headers: 'json',
    params,
  });
}

/**
 * 商行针式打印 — 销售单模板编辑
 * @param {{ stallId: number, id?: number, templateName?: string, templateBO?: { printStyle?: string, productFieldList?: string[] } }} params
 */
export async function requestNeedleOrderTemplateUpdate(params) {
  return request({
    url: 'tag/template/needle/order/update',
    headers: 'json',
    params,
  });
}

/** 商行针式打印 — 销售单模板删除 */
export async function requestNeedleOrderTemplateDelete(id) {
  return request({
    url: `tag/template/needle/order/delete?id=${id}`,
    method: 'delete',
    headers: 'json',
  });
}

/** 商行针式打印 — 设置默认销售单模板 */
export async function requestNeedleOrderTemplateUpdateDefault(params) {
  return request({
    url: 'tag/template/needle/order/updateDefault',
    method: 'put',
    headers: 'json',
    params,
  });
}

/** 商行针式打印 — 销售单模板预览（返回 PDF blob 流） */
export async function requestNeedleOrderTemplatePreview(params) {
  return request({
    url: 'tag/template/needle/order/preview',
    method: 'get',
    headers: 'json',
    params,
    responseType: 'blob',
  });
}

/** 商行针式打印 — 配货单模板预览（返回 PDF blob 流） */
export async function requestNeedleMemoTemplatePreview(params) {
  return request({
    url: 'tag/template/needle/memo/preview',
    method: 'get',
    headers: 'json',
    params,
    responseType: 'blob',
  });
}

/** 商行针式打印 — 配货单模板查看（单条） */
export async function requestNeedleMemoTemplateView(params) {
  return request({
    url: 'tag/template/needle/memo/view',
    method: 'get',
    headers: 'json',
    params,
  });
}

/** 商行针式打印 — 配货单模板编辑保存 */
export async function requestNeedleMemoTemplateEdit(params) {
  return request({
    url: 'tag/template/needle/memo/edit',
    headers: 'json',
    params,
  });
}

/** 商行热敏小票 — 码单模板详情 */
export async function requestThermalPrinterMemoTemplateView(params) {
  return request({
    url: 'tag/template/thermal/printer/memo/view',
    method: 'get',
    headers: 'json',
    params,
  });
}

/** 商行热敏小票 — 码单模板编辑保存 */
export async function requestThermalPrinterMemoTemplateEdit(params) {
  return request({
    url: 'tag/template/thermal/printer/memo/edit',
    headers: 'json',
    params,
  });
}

/** 商行热敏小票 — 销售单模板详情 */
export async function requestThermalPrinterOrderTemplateView(params) {
  return request({
    url: 'tag/template/thermal/printer/order/view',
    method: 'get',
    headers: 'json',
    params,
  });
}

/** 商行热敏小票 — 销售单模板编辑保存 */
export async function requestThermalPrinterOrderTemplateEdit(params) {
  return request({
    url: 'tag/template/thermal/printer/order/edit',
    headers: 'json',
    params,
  });
}
